module.exports = __webpack_public_path__ + "img/36_52.6cf5b4a2.png";